import React from "react";
import { Link } from "react-router-dom";
import { FaDirections } from "react-icons/fa";
import { FaWeightHanging, FaSitemap } from "react-icons/fa6";
import { MdDeliveryDining, MdOutlineCategory } from "react-icons/md";
import { RxDimensions } from "react-icons/rx";
import { TbRulerMeasure } from "react-icons/tb";
import Box from "../SharedComponents/Box";
import SetupTittle from "../SharedComponents/SetupTittle";
import SetupContainer from "../SharedComponents/SetupContainer";
import { usePermission } from "../../../context/PermissionContext";

const ITEMS = [
  {
    to: "/admin-dashboard/setup/route",
    code: "setup.route",
    title: "Routes",
    body: "Create the lane first (for example UK – Bangladesh).",
    icon: <FaDirections />,
  },
  {
    to: "/admin-dashboard/setup/measurement-unit",
    code: "setup.measurement-unit",
    title: "Measurement unit",
    body: "Units used on dimensions and weight (cm, inch, kg).",
    icon: <TbRulerMeasure />,
  },
  {
    to: "/admin-dashboard/setup/dimension",
    code: "setup.dimension",
    title: "Dimension",
    body: "Box sizes linked to a route and measurement unit.",
    icon: <RxDimensions />,
  },
  {
    to: "/admin-dashboard/setup/item-category",
    code: "setup.item-category",
    title: "Item category",
    body: "Product groups that weight bands are priced against.",
    icon: <MdOutlineCategory />,
  },
  {
    to: "/admin-dashboard/setup/delivery-plan",
    code: "setup.delivery-plan",
    title: "Delivery plan",
    body: "Economy, Standard, Express and the day range for the route.",
    icon: <MdDeliveryDining />,
  },
  {
    to: "/admin-dashboard/setup/weight",
    code: "setup.weight",
    title: "Weight",
    body: "Kg bands, per-kg cost, and which delivery plan they belong to.",
    icon: <FaWeightHanging />,
  },
  {
    to: "/admin-dashboard/setup/item-type",
    code: "setup.item-type",
    title: "Item type",
    body: "Optional item types on the same route.",
    icon: <FaSitemap />,
  },
];

const DeliverySetupHub = () => {
  const { canView } = usePermission();
  const visible = ITEMS.filter((item) => canView(item.code));

  return (
    <div>
      <Box top>
        <SetupTittle text="Delivery Setup" />
        <SetupContainer>
          <p className="text-stone-600 mb-6 max-w-3xl">
            Set up everything a customer needs when they book a kg: the route,
            box size, item group, delivery plan (with a day range), and the
            matching weight price.
          </p>
          {visible.length === 0 ? (
            <p className="text-stone-500">
              You do not have access to delivery setup screens.
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {visible.map((item, idx) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="rounded-2xl border border-stone-200 bg-white p-4 hover:border-orange-400 hover:shadow-sm transition"
                >
                  <div className="flex items-center gap-2 text-stone-800 font-semibold">
                    <span className="text-xs text-stone-400 w-5">{idx + 1}.</span>
                    <span className="text-lg text-orange-600">{item.icon}</span>
                    {item.title}
                  </div>
                  <p className="text-sm text-stone-600 mt-2">{item.body}</p>
                  <p className="text-sm font-semibold text-orange-700 mt-3">
                    Open →
                  </p>
                </Link>
              ))}
            </div>
          )}
        </SetupContainer>
      </Box>
    </div>
  );
};

export default DeliverySetupHub;
